import { InputMask } from '@react-input/mask'
import { KTextField, KTextFieldProps } from 'components/core/KTextField'
import { ForwardRefExoticComponent, RefAttributes, forwardRef } from 'react'
import { cardFromNumber, defaultCCNumberMask } from 'services'

interface KCreditCardNumberFieldProps
  extends Omit<KTextFieldProps, 'type' | 'onKeyDown'> {}

export const KCreditCardNumberField: ForwardRefExoticComponent<
  Omit<KCreditCardNumberFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const { value, ...restProps } = props
  const card = cardFromNumber(value as string)
  const mask = card?.mask ?? defaultCCNumberMask
  const replacement = { _: /\d/ }

  return (
    <KTextField
      ref={ref}
      InputProps={{ inputComponent: InputMask }}
      inputProps={{ mask, replacement }}
      value={value}
      {...restProps}
    />
  )
})
